import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addVerificationFiles } from "../requests/add-verification-files.ts";
import { verifyKeys } from "../queries/keys.ts";
import type { AddVerificationFilesRequest } from "../../types.ts";
import { danger, requestErrors } from "@/index.js";

export const useAddFilesMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: AddVerificationFilesRequest) => {
      const response = await addVerificationFiles(data);
      return response?.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [...verifyKeys.all],
      });
    },
    onError: (error) => {
      danger(requestErrors(error));
    },
     
  });
};
